import React from 'react'
import MarketsTableRow from '../MarketsTableRow'
import './index.sass'
import noDataIcon from '@assets/images/icons/no-date-icon.svg'

const MarketsTableList = ({
  coins,
  favorites,
  onToggleFavorite,
  emptyState,
  isLoading,
  vsCurrency,
  futuresPairsSlugsSet,
}) => {
  if (isLoading) {
    return (
      <tbody className="markets-table-list">
        {[...Array(5)].map((_, index) => (
          <tr key={`loading-${index}`} className="markets-table-list__loading-row markets-table-row">
            <td className="markets-table-row__cell markets-table-row__cell--pair">
              <div className="markets-table-row__cell-content markets-table-row__cell-content--meta">
                <div className="markets-table-list__skeleton markets-table-list__skeleton--icon"></div>
                <div className="markets-table-list__skeleton markets-table-list__skeleton--image"></div>
                <div>
                  <div className="markets-table-list__skeleton markets-table-list__skeleton--pair-text"></div>
                  <div className="markets-table-list__skeleton markets-table-list__skeleton--name-text"></div>
                </div>
              </div>
            </td>
            <td className="markets-table-row__cell markets-table-row__cell--price">
              <div className="markets-table-row__cell-content markets-table-row__cell-content--price">
                <div className="markets-table-list__skeleton markets-table-list__skeleton--price-text"></div>
              </div>
            </td>
            <td className="markets-table-row__cell markets-table-row__cell--change">
              <div className="markets-table-list__skeleton markets-table-list__skeleton--change-text"></div>
            </td>
            <td className="markets-table-row__cell markets-table-row__cell--market-cap">
              <div className="markets-table-row__cell-content markets-table-row__cell-content--market-cap">
                <div className="markets-table-list__skeleton markets-table-list__skeleton--market-cap-text"></div>
              </div>
            </td>
            <td className="markets-table-row__cell markets-table-row__cell--volume">
              <div className="markets-table-row__cell-content markets-table-row__cell-content--volume">
                <div className="markets-table-list__skeleton markets-table-list__skeleton--volume-text"></div>
                <div className="markets-table-list__skeleton markets-table-list__skeleton--volume-secondary"></div>
              </div>
            </td>
            <td className="markets-table-row__cell markets-table-row__cell--chart">
              <div className="markets-table-row__cell-content markets-table-row__cell-content--chart">
                <div className="markets-table-list__skeleton markets-table-list__skeleton--chart"></div>
              </div>
            </td>
            <td className="markets-table-row__cell markets-table-row__cell--action">
              <div className="markets-table-list__skeleton markets-table-list__skeleton--action"></div>
            </td>
          </tr>
        ))}
      </tbody>
    )
  }

  if (!coins.length) {
    return (
      <tbody className="markets-table-list">
        <tr>
          <td colSpan="7" className="markets-table-list__empty-cell">
            <div className="markets-table-list__content">
              <img src={noDataIcon} alt="No data" />
              <div className="markets-table-list__text">
                {emptyState}
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    )
  }

  return (
    <tbody className="markets-table-list">
      {coins.map((coin) => (
        <MarketsTableRow
          key={coin.id}
          coin={coin}
          isFavorite={favorites.has(coin.id)}
          onToggleFavorite={onToggleFavorite}
          vsCurrency={vsCurrency}
          futuresPairsSlugsSet={futuresPairsSlugsSet}
        />
      ))}
    </tbody>
  )
}

export default MarketsTableList

